import { render, staticRenderFns } from "./leaveOffice.vue?vue&type=template&id=6a6c77ba&"
import script from "./leaveOffice.vue?vue&type=script&lang=js&"
export * from "./leaveOffice.vue?vue&type=script&lang=js&"
import style0 from "./leaveOffice.vue?vue&type=style&index=0&id=6a6c77ba&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports